export const QTD_BARRAS_PLAYER_AUDIO = 30;
export const CHAVE_VELOCIDADE_AUDIO = 'chat-audio-velocidade';
